<template>
    <div>Preparando descarga...</div>
</template>

<script>
import axios from "axios";
export default {
    props: {
        grupo: String,
    },
    mounted() {
        axios
            .get("/descargar-agrupacion/" + this.grupo, {
                "Content-Disposition": "attachment",
            })
            .then((res) => {
                let downloadLabel = document.createElement("a");
                if (res.data.success) {
                    downloadLabel.href =
                        "data:application/octet-stream;base64," +
                        res.data.etiquetas.pdf;
                    downloadLabel.download = `shipro_${this.grupo}.pdf`;
                    downloadLabel.click();
                    setTimeout("window.close()", 5000);
                }
            })
            .catch((err) => console.error(err));
    },
};
</script>
